export default "__VITE_ASSET__DttX20Qm__"